/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricDimensionOutput } from './rubricDimensionOutput';

/**
 * Rubric for a task, fits multiple versions
 */
export interface TaskRubricV2Output {
  reasoningFlowchart: string;
  dimensions: RubricDimensionOutput[];
}
